import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { ReportAccessType } from "../../shared/reporting/api/biClient.types";
import { useEnhancedBiApiClientProvider } from "../contexts/ApiClientProviderContext";
import { useClientContext } from "../contexts/ClientContext";
import { AppDispatch } from "../store/store";
import { setEditReport } from "../store/thunks/currentReportThunks";
import { getNewReport } from "../store/utils/currentReportSlice.helper";
import { createCurrentReportAction } from "../store/utils/storeUtils";
import { getExistingReportWithAuth, manageReportSwitching } from "../utilities/defineReportDataHelper";

export const useDefineEditReportData = () => {
  const { id } = useParams();
  const { clientCode } = useClientContext();
  const { getReport, getReportAuthorizationInfo } = useEnhancedBiApiClientProvider();
  const dispatch: AppDispatch = useDispatch();
  const [showReportNotFound, setShowReportNotFound] = useState(false);
  const [isSwitchingReport, setShowSwitchingReport] = useState(false);
  const cachedReportId = useRef<string | undefined>(undefined);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const isSwitchingReport = !!cachedReportId.current && cachedReportId.current !== id;
    cachedReportId.current = id;

    if (id === undefined) {
      return;
    }

    const execute = async () => {
      setIsFetching(true);
      if (id === "new") {
        dispatch(setEditReport(getNewReport(clientCode)));
        dispatch(
          createCurrentReportAction("setAuthorizationInfo", {
            access: ReportAccessType.Owner,
            own: true,
            private: true,
          })
        );
      } else {
        await getExistingReportWithAuth(
          getReport.bind(null, id, "edit"),
          undefined,
          getReportAuthorizationInfo.bind(null, id),
          () => setShowReportNotFound(true),
          (report) => dispatch(setEditReport(report)),
          (authInfo) => dispatch(createCurrentReportAction("setAuthorizationInfo", authInfo))
        );
      }
      setIsFetching(false);
    };
    manageReportSwitching(isSwitchingReport, setShowSwitchingReport, execute);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, clientCode, getReport, getReportAuthorizationInfo]);

  return { showReportNotFound, isSwitchingReport, isFetching };
};
